export enum LayoutType {
  Row = 'ROW',
  Column = 'COLUMN',
}
